export const mentionCandidates = [{ id: 0, display: "PREP" }];

// @[display](id) 형태의 멘션 파싱 정규식
const mentionRegex = /@\[[^\]]+\]\((\d+)\)/g;

export const matchMention = (content) => {
    return mentionRegex.exec(content);
};

export const hasMention = (content) => {
    return mentionRegex.exec(content) !== null;
};

export const hasPrepMention = (content) => {
    return content && content.indexOf("@[PREP](0)") > -1;
};
